// types
import { i18nEaiUsers } from 'models/i18n';
import { UserAccountStatus } from 'utils/constants';

// ==============================|| I18N EN USERS ||============================== //

const enEaiUsers: i18nEaiUsers = {
  createUserWizard: {
    title: 'Create user',
    step01: 'User data',
    save: 'Create user'
  },
  userList: {
    title: 'User List',
    searchInput: 'Enter e-mail',
    createEntityButton: 'Create user',
    columns: {
      username: 'Username/E-mail',
      firstname: 'First name',
      lastname: 'Last name',
      status: 'Status'
    },
    userActions: {
      detail: 'Detail',
      enable: 'Enable',
      disable: 'Disable'
    }
  },
  userDetail: {
    userProfile: {
      title: 'Profile',
      basicInfo: 'Basic info',
      accountStateSwitch: 'Active',
      accountState: {
        [UserAccountStatus.ENABLED]: 'Disable user',
        [UserAccountStatus.DISABLED]: 'Enable user'
      },
      resetPassword: 'Reset password',
      deleteUser: 'Delete user'
    },
    userAssignment: {
      title: 'User assignment',
      columns: {
        subjectAccount: 'Subject account',
        accountType: 'Account type',
        memberAccountStatus: 'Member account status',
        roles: 'Roles',
        actions: 'Actions'
      },
      addMemberAccount: 'Add subject',
      rolesAssignment: {
        columns: {
          role: 'Role',
          validFromDate: 'Created',
          actions: 'Actions'
        },
        addRole: 'Add role'
      }
    }
  },
  input: {
    email: 'Username/E-mail',
    firstName: 'First name',
    lastName: 'Last name',
    emsMemberAccountId: 'Associated account of the entity',
    role: 'User role',
    username: 'Username/E-mail'
  },
  validation: {
    'email-required': 'Username/E-mail is mandatory',
    'email-matches': 'Username/E-mail is not valid',
    'email-exists': 'Username/E-mail must be unique',
    'firstName-required': 'First name is mandatory',
    'lastName-required': 'Last name mandatory',
    'emsMemberAccountId-required': 'Associated account of the entity mandatory'
  }
};

export default enEaiUsers;
